import m from 'mithril'
import moment from 'moment' 
import WeatherData from "./weather-data.js"
import Location from "../shared/location.js"
import FuzzyClock from "../fuzzy/fuzzy.js"
import StatusBar from "../shared/statusbar.js"
import './weather.css';

var dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export default function Weather (vnode) {
  var updateInterval = 15 * 60 * 1000;
  var timestamp = undefined;

  return {
    oninit: function(vnode) {
      setTimeout(this.update, 1);
      this.interval = setInterval(this.update, updateInterval)
    },
    onremove: function() {
      clearTimeout(this.interval)
    },
    update: function() {
      Location.init().then(WeatherData.fetch())
      .then(function(response) {
        if (Weather.timestamp != response.timestamp) {
          document.redraw(true)
          Weather.timestamp = response.timestamp;
        }
      })
    },
    view: function(vnode) {
      var attrs = vnode.attrs;
      var data = WeatherData.response;
      var components = [];
      var isWidget = attrs && (attrs.class == "widget")
      if (!isWidget) {
        components = [ m(StatusBar), m(FuzzyClock, {class:"widget"}) ];
      }
      components.push(m(TodayWeather, {data:data}));
      if (data && !isWidget) {
        components.push(m(WeeklyWeather, {data:data}));
      }
      return m("div#weather-container", {class: isWidget ? "widget" : undefined}, components)
    }
  }
}

var TodayWeather = {
  view: function(vnode) {
    var data = vnode.attrs.data;

    var locationElement = m('div.location', {onclick:function() {
      Location.ask().then(function() {
        WeatherData.reload().then(function(){
          m.redraw();
        });
      })
    }}, Location.name + " ");

    if (!data) {
      return m('div', {class:'today', onclick:function() {location.reload()}},
        locationElement,
        m('br'),
        "Loading...");
    }
    var currentTemp = data.currently.apparentTemperature
    var highTemp = currentTemp;
    var highTempTime = undefined;
    var lowTemp = currentTemp;
    var lowTempTime = undefined;
    var now = data.hourly.data[0].time;
    for (var i = 0; i < data.hourly.data.length && i < 12; i++) {
      var hour = data.hourly.data[i]
      var temp = hour.apparentTemperature
      if (temp > highTemp) {
        highTemp = temp;
        highTempTime = hour.time
      }
      if (temp < lowTemp &&  i < 4) {
        lowTemp = temp;
        lowTempTime = hour.time
      }
      highTemp = Math.max(highTemp, hour.apparentTemperature)
      lowTemp = Math.min(lowTemp, hour.apparentTemperature)
    }

    var targetTime = highTemp - currentTemp > 1 ? (highTempTime - now) : (lowTempTime - now);
    var targetDate = moment().add(targetTime * 1000).format("[at ]h a");

    var targetTemp = highTemp - currentTemp > 1 ? highTemp : lowTemp

    return m('div', {class:'today'},
      m('table', {class:'currently'},
        m('tr.details', 
          m('td', {colspan:2}, locationElement),
          m('td.targetTime',targetDate)
        ),
        m('tr.temperatures',
          m('td.currentTemp', Math.round(currentTemp)),
          m('td.tempArrow', {class:'arrow_' + (targetTemp > currentTemp ? "rising" : "falling")}),
          m('td.targetTemp', Math.round(targetTemp) + "°")
        )
      ),
      m('p', {class:'summary'}, data.hourly.summary)
    );
  }
}
var WeeklyWeather = {
  view: function(vnode) {
    var date = new Date();
    var data = vnode.attrs.data;
    var day = date.getDay();

    var isWeekend = (day + 8) % 7 < 2;
    var days = []
    for (var i = 0; i < 5; i++) {
      var dayOfWeek = (day+i)%7;
      days.push(m(Day, {day:data.daily.data[i], index:dayOfWeek, name:dayNames[dayOfWeek]}));
    }

    return m('div#upcoming',
      m('div', {class:isWeekend ? 'upcoming isweekend' : 'upcoming'}, days),
      m('p'),
      m('p.summary', data.daily.summary),
      m('p.timestamp', moment().format("[updated] h:mm a"))
    )
  }
}
var Day = {
  view: function(vnode) {
    var day = vnode.attrs.day;
    var isWeekend = (vnode.attrs.index + 8) % 7 < 2;
    return m('div', {class:'day' + (isWeekend ? " weekend" : "")}, [
      m('div.name', " " + vnode.attrs.name),
      m('div.weather-icon', {class:day.icon}),        
      m('div.tempRange', 
        m('div.tempHigh', Math.round(day.apparentTemperatureMax)),
        m('div.tempLow', Math.round(day.apparentTemperatureMin))
      )
    ])
  }
}